<script>
  import { handleViewportSize } from '@/lib/vue-helpers.js';
  export default {
    name: 'PDPVideoPlayer',
    props: {
      sources: {
        type: Array,
        required: true
      },
      productID: {
        type: String,
        required: true
      },
      handleVideoSize: {
        type: Function,
        required: true
      }
    },
    data() {
      return {
        isPlaying: false
      };
    },
    methods: {
      playVideo() {
        const video = this.$refs.video;
        video.play();
        this.isPlaying = true;
      },
      pauseVideo() {
        const video = this.$refs.video;
        video.pause();
        this.isPlaying = false;
      },
      setVideoPlaying() {
        this.handleVideoSize();
        this.playVideo();
      }
    },
    mounted() {
      document.addEventListener('theme:resize', () => {
        setTimeout(() => {
          this.handleVideoSize();
        }, 100);
      });
      this.handleVideoSize();
      this.handleViewportSize = handleViewportSize(this);
    },
    beforeUnmount() {
      if (this.handleViewportSize) this.handleViewportSize();
    }
  };
</script>

<template>
  <div class="pdp-video-player">
    <video ref="video" v-if="sources" width="100%" height="100%" autoplay muted loop playsinline @loadeddata="setVideoPlaying()">
      <source v-for="source in sources" :key="source.url" :src="source.url" :type="source.mimeType" />
    </video>

    <div class="video-controls" v-if="sources" :data-is-playing="isPlaying">
      <button class="video-control-button play-button" @click="playVideo()">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5Z" fill="white" stroke="#737373" stroke-width="1.5" stroke-miterlimit="10" />
          <path d="M15.2332 26.3661V13.6328L26.3665 19.9995L15.2332 26.3661Z" fill="#737373" />
        </svg>

        <span class="visually-hidden">Play</span>
      </button>
      <button class="video-control-button pause-button" @click="pauseVideo()">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 37.5C29.665 37.5 37.5 29.665 37.5 20C37.5 10.335 29.665 2.5 20 2.5C10.335 2.5 2.5 10.335 2.5 20C2.5 29.665 10.335 37.5 20 37.5Z" fill="white" stroke="#737373" stroke-width="1.5" stroke-miterlimit="10" />
          <path d="M24.7668 12.0508V27.9508" stroke="#737373" stroke-width="3" stroke-miterlimit="10" />
          <path d="M15.2332 27.9508V12.0508" stroke="#737373" stroke-width="3" stroke-miterlimit="10" />
        </svg>
        <span class="visually-hidden">Pause</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss">
  #PDPImages,
  #pdp-freescroll-target {
    .desktop-video-height {
      overflow: hidden;
    }

    .carousel li .pdp-video-player {
      overflow: hidden;
    }

    .pdp-video-player {
      height: 100%;
      width: 100%;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
        &::-webkit-media-controls {
          display: none;
        }
      }
    }

    .video-controls {
      position: absolute;
      bottom: 0px;
      opacity: 0.5;
      .is-mobile & {
        bottom: 10px;
      }
      &[data-is-playing='true'] {
        .play-button {
          display: none;
        }
      }
      &[data-is-playing='false'] {
        .pause-button {
          display: none;
        }
      }
    }
  }
</style>
